import React from 'react';
import { motion } from 'framer-motion';
import { Award, Leaf, Lightbulb, Cpu, Heart, Search } from 'lucide-react';

export function OurValues() {
  const values = [
    {
      title: 'Calidad',
      description: 'Excelencia en cada componente y proceso de fabricación.',
      icon: <Award className="w-8 h-8" />
    },
    {
      title: 'Sostenibilidad',
      description: 'Compromiso real con el medio ambiente y la movilidad verde.',
      icon: <Leaf className="w-8 h-8" />
    },
    {
      title: 'Innovación',
      description: 'Búsqueda constante de nuevas soluciones y mejoras.',
      icon: <Lightbulb className="w-8 h-8" />
    },
    {
      title: 'Tecnología',
      description: 'Vanguardia en electrónica y sistemas de control.',
      icon: <Cpu className="w-8 h-8" />
    },
    {
      title: 'Confianza',
      description: 'Relaciones duraderas con nuestros usuarios y partners.',
      icon: <Heart className="w-8 h-8" />
    },
    {
      title: 'Transparencia',
      description: 'Claridad en nuestra comunicación y servicios.',
      icon: <Search className="w-8 h-8" />
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl md:text-4xl font-bold text-gray-900 mb-6"
          >
            Nuestros Valores
          </motion.h2>
          <p className="text-lg text-gray-600">
            Los principios fundamentales que guían cada decisión en ZWheel.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <motion.div
              key={value.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group p-8 rounded-2xl bg-gray-50 hover:bg-white border border-transparent hover:border-gray-100 hover:shadow-xl transition-all duration-300 text-center"
            >
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white text-gray-900 shadow-sm mb-6 group-hover:scale-110 group-hover:bg-black group-hover:text-white transition-all duration-300">
                {value.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {value.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {value.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
